/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sd_Trial_Too_LongInputs */

const en_sd_trial_too_long = /** @type {(inputs: Sd_Trial_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This video is longer than the 5-minute trial limit. Please shorten the clip or activate your account.`)
};

const fr_sd_trial_too_long = /** @type {(inputs: Sd_Trial_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette vidéo dépasse la limite de 5 minutes de l'essai gratuit. Veuillez la raccourcir ou activer votre compte.`)
};

const de_sd_trial_too_long = /** @type {(inputs: Sd_Trial_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Video ist länger als die im Testzeitraum zulässigen 5 Minuten. Bitte kürzen Sie den Clip oder aktivieren Sie Ihr Konto.`)
};

const it_sd_trial_too_long = /** @type {(inputs: Sd_Trial_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo video è più lungo del limite di 5 minuti previsto per la prova. Si prega di accorciare il video o di attivare il proprio account.`)
};

const ru_sd_trial_too_long = /** @type {(inputs: Sd_Trial_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это видео длиннее, чем установленный пробный лимит в 5 минут. Пожалуйста, сократите ролик или активируйте свою учетную запись.`)
};

const es_sd_trial_too_long = /** @type {(inputs: Sd_Trial_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este vídeo supera el límite de 5 minutos de la prueba gratuita. Por favor, acórtalo o activa tu cuenta.`)
};

const zh_cn2_sd_trial_too_long = /** @type {(inputs: Sd_Trial_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此视频时长超过5分钟试用限制。请缩短视频或激活您的帐户。`)
};

const ja_sd_trial_too_long = /** @type {(inputs: Sd_Trial_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この動画は5分間の無料トライアル期間を超えています。動画を短くするか、アカウントを有効化してください。`)
};

const hi_sd_trial_too_long = /** @type {(inputs: Sd_Trial_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह वीडियो 5 मिनट की परीक्षण सीमा से अधिक लंबा है। कृपया वीडियो को छोटा करें या अपना खाता सक्रिय करें।`)
};

const pt_pt2_sd_trial_too_long = /** @type {(inputs: Sd_Trial_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este vídeo é mais longo do que o limite de 5 minutos do período de teste. Por favor, reduza a duração do vídeo ou ative sua conta.`)
};

/**
* | output |
* | --- |
* | "This video is longer than the 5-minute trial limit. Please shorten the clip or activate your account." |
*
* @param {Sd_Trial_Too_LongInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sd_trial_too_long = /** @type {((inputs?: Sd_Trial_Too_LongInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sd_Trial_Too_LongInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_sd_trial_too_long(inputs)
	if (locale === "de") return de_sd_trial_too_long(inputs)
	if (locale === "it") return it_sd_trial_too_long(inputs)
	if (locale === "ru") return ru_sd_trial_too_long(inputs)
	if (locale === "es") return es_sd_trial_too_long(inputs)
	if (locale === "zh-CN") return zh_cn2_sd_trial_too_long(inputs)
	if (locale === "ja") return ja_sd_trial_too_long(inputs)
	if (locale === "hi") return hi_sd_trial_too_long(inputs)
	if (locale === "pt-PT") return pt_pt2_sd_trial_too_long(inputs)
	return en_sd_trial_too_long(inputs)
});